<div class="relative w-full bg-white p-12 shadow-lg mt-[80px]">
    <div class="max-w-7xl mx-auto flex items-center justify-start">
        <h1 class="text-3xl font-bold text-gray-900 ml-0 md:ml-4 aARNI -font">Education Loan Assistance</h1>
    </div>
</div>

<div class="flex items-start justify-center p-4 bg-gray-50 aARNI -font">
    <div class="flex flex-col lg:flex-row gap-4 p-4 w-full max-w-7xl">
        <aside class="w-full lg:w-1/4 space-y-4 lg:h-[950px] lg:overflow-y-auto">
            <div class="border-t-8 border-blue-400">
                <div class="bg-white shadow border border-gray-300">
                    <h2 class="text-lg font-bold p-4">Applying to ARNI</h2>
                    <div>
                        <a
                            href="/admissions/overview"
                            [ngClass]="{
            'bg-blue-600 text-white border-blue-400': isActive('/admissions/overview'),
            'text-blue-600 hover:bg-blue-400 hover:text-white hover:border-blue-400': !isActive('/admissions/overview')
          }"
                            class="flex items-center space-x-2 p-3 w-full cursor-pointer border-y border-gray-300 transition duration-300"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Overview</span>
                        </a>

                        <a
                            *ngFor="let link of [
            { href: '/admissions/campus-virtual-tour', label: 'Campus Virtual Tour' },
            { href: '/admissions/criteria', label: 'Admission Criteria' },
            { href: '/admissions/flow', label: 'Admission Flow' },
            { href: '/admissions/program-fee', label: 'Program Fees' },
            { href: '/admissions/hostel-fee', label: 'Accommodation & Hostel' },
            { href: '/admissions/transportation-fee', label: 'Transportation Services' },
            { href: '/admissions/scholarship', label: 'Scholarship Opportunities' },
            { href: '/admissions/innovative-idea-scholarship', label: 'Innovative Idea Grants' },
            { href: '/admissions/fee-structure-for-previous-year-students', label: 'Fee Structures for Previous Year Students' },
            { href: '/admissions/education-loan-assistance', label: 'Education Loan Support' },
            { href: '/admissions/how-to-apply', label: 'How to Apply' },
            { href: '/quick-links/contact-us', label: 'Counseling Services' },
            { href: '/admissions/payment-procedure', label: 'Payment Procedure' },
            { href: '/admissions/refund-policy', label: 'Refund Policy' },
            { href: '/admissions/avenues-for-success', label: 'Avenues for Success@ARNI' },
            { href: '/admissions/lateral-entry-or-migration', label: 'Lateral Entry/Migration' },
            { href: '/admissions/faqs', label: 'FAQs' }
          ]"
                            [href]="link.href"
                            [ngClass]="{
            'bg-blue-600 text-white border-blue-400': isActive(link.href),
            'text-blue-600 hover:bg-blue-400 hover:text-white hover:border-blue-400': !isActive(link.href)
          }"
                            class="flex items-center space-x-2 p-3 w-full cursor-pointer border-b border-gray-300 transition duration-300"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>{{ link.label }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </aside>
        <section class="flex-1 shadow-lg p-4 border-2 border-gray-200 h-fit bg-white aarni-font text-justify">
            <h2 class="text-2xl font-bold mb-4">Fee Structure for Previous Year Students</h2>
            <p class="my-2 text-gray-800">ARNI  University is committed to supporting deserving and meritorious students in obtaining
                financial assistance for their higher education.</p>
            <p class="my-2 text-gray-800">Students can avail education loans from any bank. However, for the benefit of its students,
                ARNI  University has established tie-ups with the following banks:</p>
            <p class="font-bold mt-4 text-lg text-gray-800">Assistance available for all banking-related concerns.</p>

            <div class="flex sm:flex-col md:flex-row gap-5 sm:gap-5 md:gap-10 justify-center m-5">
                <a href="https://www.grayquest.com/" target="_blank"><img src="assets/img/admissions/grayquest.jpeg"
                                                                          class="object-cover rounded md:ml-10"/></a>
                <a href="https://www.kotak.com/en/home.html" target="_blank"> <img
                    src="assets/img/admissions/kotak_mahindra.png" class="object-cover rounded md:mr-10"/></a>
            </div>
            <p class="my-4 text-gray-800">ARNI  University assists its students in the prompt processing of their education loan
                applications across
                the country. To further support students seeking financial assistance, a dedicated loan assistance kiosk
                is set up within the campus during the months of June to August.</p>
            <p class="mb-4 font-semibold">Procedure for Availing Bank Loan Assistance</p>
            <p class="mb-2 text-gray-800">Students seeking to apply for an educational loan must obtain an offer letter
                from ARNI  University. The
                University will issue the necessary offer letter required by the bank for loan processing, subject to
                its discretion and as deemed appropriate.</p>
            <p class="text-gray-800">However, it is the sole responsibility of the students and their
                parents/guardians to secure the loan sanction, ensure repayment of the sanctioned loan, and bear all
                liabilities and consequences arising therefrom, if any. ARNI  University shall not be held liable or
                responsible in this regard under any circumstances.</p>
            <p class="my-4 font-semibold">Economically Weaker Section (EWS) – Guidelines for Education Loan</p>
            <p class="mb-2 text-gray-800">Under the Central Scheme to provide Interest Subsidy, students belonging to the Economically
                Weaker Section (EWS) can avail interest subsidy during the moratorium period on educational loans taken
                from Scheduled Banks, as per the Model Education Loan Scheme of the Indian Banks’ Association
                (IBA)..</p>
            <p class="mb-2 text-gray-800">This scheme aims to support meritorious students from economically disadvantaged backgrounds
                by reducing their financial burden during the course of their higher education.</p>
            <p class="mb-4 text-gray-800">For more details regarding eligibility, documentation, and application process, students are
                advised to contact their respective banks or visit the official government education loan portal.</p>
            <p class="text-blue-400 font-semibold text-md">EWS Loan Scheme - Government of India</p>
            <p class="text-blue-400 font-semibold text-md">Model Education Loan Scheme - Kotak Mahindra Bank</p>
            <p class="text-blue-400 font-semibold text-md">Annexure : Revised IBA Guidelines (31.05.2012) on Model
                Education Loan Scheme</p>
        </section>
    </div>

</div>
